import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c3fdd2f")

_pushScopeId("data-v-4c3fdd2f")
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_edit_permission_group",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "row align-items-end g-9" }
const _hoisted_9 = { class: "col-md-9 fv-row" }
const _hoisted_10 = { class: "col-md-3 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_12 = { class: "d-flex align-items-center fs-6 fw-bold mb-3" }
const _hoisted_13 = { class: "customer-permissions" }
const _hoisted_14 = { class: "list-group list-group-flush m-0" }
const _hoisted_15 = { class: "checkbox" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "default" }, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "d-flex align-items-center fs-7 mt-3" }
const _hoisted_19 = { class: "modal-footer flex-center" }
const _hoisted_20 = {
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_21 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.ability,
          ref: "editPermissionGroup"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.EDIT')} ${_ctx.$t('message.PERMISSIONS_GROUP')}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_Input, {
                      type: "text",
                      name: "name",
                      label: _ctx.$t('message.NAME'),
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                      requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.ability.name = $event)),
                      target: "name",
                      required: true,
                      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateValue(_ctx.ability.name))),
                      value: _ctx.ability.name
                    }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_Select, {
                      name: "locale",
                      target: "locale",
                      callEmit: true,
                      required: false,
                      label: false,
                      locale: _ctx.locale,
                      "onUpdate:locale": _cache[3] || (_cache[3] = ($event: any) => (_ctx.locale = $event)),
                      selectData: _ctx.locales,
                      value: _ctx.locale,
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeLang(_ctx.locale)))
                    }, null, 8, ["locale", "selectData", "value"])
                  ])
                ]),
                _createVNode(_component_Input, {
                  type: "text",
                  name: "search",
                  label: _ctx.$t('message.SEARCH'),
                  placeholder: `${_ctx.$t('message.SEARCH')} ${_ctx.$t('message.VALUE')}`,
                  search: _ctx.search,
                  "onUpdate:search": _cache[5] || (_cache[5] = ($event: any) => (_ctx.search = $event)),
                  target: "search",
                  value: _ctx.search
                }, null, 8, ["label", "placeholder", "search", "value"]),
                _hoisted_11,
                _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('message.PERMISSIONS')), 1),
                _createVNode("div", _hoisted_13, [
                  _createVNode("ul", _hoisted_14, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.abilities, (ability) => {
                      return (_openBlock(), _createBlock("li", {
                        class: "list-group-item",
                        key: ability
                      }, [
                        _createVNode("label", _hoisted_15, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedAbility = $event)),
                            value: `${ability.id}`
                          }, null, 8, ["value"]), [
                            [_vModelCheckbox, _ctx.selectedAbility]
                          ]),
                          _hoisted_16
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`message.${ability?.value.toUpperCase()}`)), 1)
                      ]))
                    }), 128)),
                    (_ctx.abilities.length == 0)
                      ? (_openBlock(), _createBlock("li", _hoisted_17, [
                          _createVNode("div", null, [
                            _createVNode(_component_el_empty, {
                              description: _ctx.$t('message.NO_RECORD_FOUND')
                            }, null, 8, ["description"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('message.ASSIGN_PERMISSIONS')) + " (" + _toDisplayString(_ctx.selectedAbility.length) + ")", 1)
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("button", _hoisted_20, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitHandler && _ctx.submitHandler(...args)))
              }, [
                _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
})